// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__MvJ7R","header__img":"styles_header__img__e6kXc","header__body":"styles_header__body__HowGp","back":"styles_back___Pn2E"};